(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-catalogue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseCatalogueSliders() {
      if (!window.Webflow || typeof window.Webflow.require !== 'function') return;
      const slider = window.Webflow.require('slider');
      if (slider && typeof slider.ready === 'function') slider.ready();
    }
    window.Webflow = window.Webflow || [];
    window.Webflow.push(initialiseCatalogueSliders);
    document.addEventListener('shopify:section:load', event => {
      if (event.target.querySelector('[data-home-catalogue]')) initialiseCatalogueSliders();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseLandingSliders() {
      if (!window.Webflow || typeof window.Webflow.require !== 'function') return;
      const slider = window.Webflow.require('slider');
      if (slider && typeof slider.ready === 'function') slider.ready();
    }
    window.Webflow = window.Webflow || [];
    window.Webflow.push(initialiseLandingSliders);
    document.addEventListener('shopify:section:load', event => {
      if (event.target.querySelector('[data-homepage-landing]')) initialiseLandingSliders();
    });
    document.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('[data-landing-block]');
      if (!slide) return;
      const slider = slide.closest('.w-slider');
      const index = Array.from(slider.querySelectorAll('[data-landing-block]')).indexOf(slide);
      const dot = slider.querySelectorAll('.w-slider-dot')[index];
      if (dot) dot.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
